module.exports = __webpack_public_path__ + "static/media/KICFreezer.16910f24.png";